// Customizable Area Start
import React from "react";
import { withRouter } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { createStyles, Theme } from "@material-ui/core/styles";
import { Dialog, DialogContent, styled, withStyles } from "@material-ui/core";
import { NewPostCreationSteps } from "./enums";
import NewPostController from "./NewPostController.web";
import NewPostAddCaption from "./NewPostAddCaption.web";
import NewPostCover from "./NewPostCover.web";
import NewPostPreview from "./NewPostPreview.web";
import FileDropzoneModal from "./FileDropzoneModal.web";
import EverybrandLibrary from "./EverybrandLibrary.web";
import InstagramLibrary from "./InstagramLibrary.web";
import TikTokLibrary from "./TikTokLibrary.web";

const styles = (theme: Theme) =>
  createStyles({
    postDialogPaper: {
      borderRadius: "8px 8px 32px 8px",
      maxWidth: "810px",
      "& > .MuiDialogContent-root": {
        padding: "0px",
      },
      [theme.breakpoints.down(450)]: {

      },
    },
    postDialogPaperFullWidth: {

    }
  });

const CustomDialog = styled(Dialog)(({theme}) => ({
  "& .MuiDialog-paper": {
    borderRadius: "8px 8px 32px 8px",
    [theme.breakpoints.down(450)]: {
      margin: "0px",
    },
  },
  "& .MuiDialog-paperFullWidth":{
    [theme.breakpoints.down(450)]: {
      width: 'calc(100% - 24px)'
    },
  },
  "& > .MuiDialogContent-root": {
    padding: "0px",
  },
  [theme.breakpoints.down(450)]: {
    
  },
}))

export class NewPost extends NewPostController {
  render() {
    const { classes, navigation } = this.props;
    const {
      currentStep,
      files,
      cover,
      poll,
      captionView,
      caption,
      bodyText,
      isCommentsAllowed,
    } = this.state;

    return (
      <>
        <CssBaseline />
        <CustomDialog
          open
          fullWidth
          maxWidth="md"
          onClose={(_event, reason) => {
            // Opening the native file picker (video upload) from inside this modal
            // makes the browser register a spurious backdrop click when focus
            // returns, which would otherwise close this dialog mid-upload.
            if (reason === "backdropClick") {
              return;
            }
            this.closeModal();
          }}
        >
          <DialogContent>
            {currentStep === NewPostCreationSteps.SELECT_FILE && (
              <FileDropzoneModal
                postType="post"
                files={files}
                setFiles={this.setFiles}
                setStep={this.setStep}
                closeModal={this.closeModal}
                openLibrary={() => this.setStep(NewPostCreationSteps.EVERYREEL_LIBRARY)}
                libraryType="SOCIAL_SCROLL"
              />
            )}
            {currentStep === NewPostCreationSteps.EVERYREEL_LIBRARY && (
              <EverybrandLibrary goBack={this.handleSetMediaSelectionStep} setFiles={this.setFiles} libraryType="SOCIAL_SCROLL"/>
            )}

            {currentStep === NewPostCreationSteps.ADD_CAPTION && (
              <NewPostAddCaption
                files={files}
                poll={poll}
                view={captionView}
                caption={caption}
                setStep={this.setStep}
                closeModal={this.closeModal}
                setCaption={this.setCaption}
                setPollQuestion={this.setPollQuestion}
                setPollAnswer1={this.setPollAnswer1}
                setPollAnswer2={this.setPollAnswer2}
                setCaptionView={this.setCaptionView}
              />
            )}
            {currentStep === NewPostCreationSteps.COVER_SELECTION && (
              <NewPostCover
                files={files}
                setStep={this.setStep}
                postCaption={bodyText}
                allowComments={this.allowComments}
                isCommentsAllowed={isCommentsAllowed}
                closeModal={this.closeModal}
                caption={caption}
                setCover={this.setCover}
                sendPost={this.sendPost}
                isPostButtonDisabled={this.state.isPostButtonDisabled}
                isLoaderShow={this.state.isLoaderShow}
                postBodyMessage={this.state.postBodyMessage}
                cover={cover}
                handlePostCaptionChange={this.handlePostCaptionChange}
                handleSelectPlatforms={this.handleSelectPlatforms}
              />
            )}
            {currentStep === NewPostCreationSteps.POST_PREVIEW && (
              <NewPostPreview
                files={files}
                cover={cover}
                caption={bodyText}
                poll={poll}
                closeModal={this.closeModal}
                setStep={this.setStep}
                sendPost={this.sendPost}
              />
            )}
          </DialogContent>
          {currentStep === NewPostCreationSteps.INSTAGRAM_LIBRARY && (
              <InstagramLibrary
                navigation={navigation}
                setFiles={this.setFiles}
                handleGoBack={this.handleSetMediaSelectionStep}
              />
            )}
            {currentStep === NewPostCreationSteps.TIK_TOK_LIBRARY && (
              <TikTokLibrary
                navigation={navigation}
                setFiles={this.setFiles}
                handleGoBack={this.handleSetMediaSelectionStep}
              />
            )}
        </CustomDialog>
      </>
    );
  }
}

export default withStyles(styles)(withRouter(NewPost));
// Customizable Area End
